import style from "./style.scss";
import { mergeClasses } from "../helpers";

const BigText = ({ uppercase = false, children }) => (
  <span
    class={mergeClasses([style.bigText, uppercase ? style.uppercase : null])}
  >
    {children}
  </span>
);

export default BigText;
